import React from 'react'
import {HashLink} from 'react-router-hash-link'

import {APP_ROUTES} from '../../routes/routes'

const FooterCareerLinks = () => {
  const careerLinks = [
    {id: 'careers-open-positions', label: 'Job openings'},
    {id: 'reasons', label: 'Life at Creditstar'}
  ]

  const links = careerLinks.map(({id, label}) => {
    return (
      <li className="footer-link" key={`footer-career-links-${id}`}>
        <HashLink className="footer-link" to={`${APP_ROUTES.CAREERS}#${id}`}>
          {label}
        </HashLink>
      </li>
    )
  })

  return (
    <ul>
      <li className="footer-link heading">Careers</li>
      {links}
    </ul>
  )
}

export default FooterCareerLinks
